<template>
  <div class="campaign-table table-component">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :fields="tableFields"
                   :search="tableData.search" :enable-simple-search="false"
                   @paramsChanged="getCampaignTableData">

      <template slot="cell(title)" slot-scope="{item: campaign}">
        {{campaign.title}}
        <action-buttons @editClick="onEditClick(campaign)" :view="false" :remove="false"/>
      </template>

      <template slot="cell(scheduled_at)" slot-scope="{item: campaign}">
        {{campaign.scheduled_at | toDateTime}}
      </template>

      <template v-slot:header-buttons="{selectedItems}">
        <b-button class="ml-2" variant="primary" @click="onNewCampaignClick">
          {{$t('New Campaign')}}
        </b-button>
      </template>

    </artisio-table>
  </div>
</template>

<script>
  import i18nHelper from "./../../../../core/services/i18n.service";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "../../../../core/components/ams-table/ArtisioTable";
  import i18n from "../../../../shared/i18n";
  import ActionButtons from "@/core/components/ams-table/ActionButtons";
  import {SOURCE_CAMPAIGNS_LIST} from "@/modules/constants";

  const {mapState, mapActions} = createNamespacedHelpers('marketing/audience');

  export default {
    name: "CampaignsTable",
    components: {ActionButtons, ArtisioTable},
    props: {},
    data: () => {
      return {
        masterLanguage: i18nHelper.getMasterLanguage(),
        tableFields: [
          {key: "title", label: i18n.t('Title'), sortable: true},
          // {key: "subject", label: i18n.t('Subject'), sortable: true},
          // {key: "from_name", label: i18n.t('From Name'), sortable: true},
          // {key: "reply_to", label: i18n.t('Reply to'), sortable: true},
          {key: "scheduled_at", label: i18n.t('Schedule Date'), sortable: true},
        ],
      }
    },
    computed: {
      ...mapState({
        tableData: state => state.view.campaignTableData,
        audience: state => state.view.audience
      }),
    },
    methods: {
      ...mapActions(['getCampaignTableData', 'showCampaignModal']),
      onNewCampaignClick() {
        this.showCampaignModal({
          object: {audience_uuid: this.audience.uuid},
          source: SOURCE_CAMPAIGNS_LIST
        })
      },
      onEditClick(campaign) {
        this.showCampaignModal({object: campaign, source: SOURCE_CAMPAIGNS_LIST})
      },
    },
    mounted() {
      this.getCampaignTableData();
    },
  }
</script>

<style lang="scss" scoped>
  /deep/ .table-sm.table-responsive {
    height: 37em;
  }
</style>

